import { useCallback, useContext, useEffect, useState } from "react";
import Form from "rc-field-form";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import Field from "../../../../../components/Field";
import ResourceSelect from "../../../../../components/Inputs/ResourceSelect";
import Button from "../../../../../components/Button";
import { ProfileContext } from "../../../context";
import { usePeopleApi } from "../../../../../utils/api/people";
import {
    renderSettingsResourceLabel,
    getSettingsResourceSearchFilters
} from "../../../../../utils/helpers/settings";
import { generateErrorsConfigForForm } from "../../../../../utils/helpers/errors";

function ChangePayCodes({ close }) {
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const {
        user,
        submit,
        submitting,
        submittingError
    } = useContext(ProfileContext);

    const [type, setType] = useState(user?.allowedPayCodes?.length > 0 ? "include" : "exclude");

    const { changePayCodes: peopleSubmit } = usePeopleApi();

    const onTypeClick = useCallback((value) => {
        const field = value === "include" ? "excludedPayCodes" : "allowedPayCodes";
        setType(value);
        form.setFieldValue(field, []);
    }, [form]);

    const onFinish = useCallback((values) => {
        const data = {
            allowedPayCodes: type === "include" ? values?.allowedPayCodes?.map(({ id }) => id) : [],
            excludedPayCodes: type === "exclude" ? values?.excludedPayCodes?.map(({ id }) => id) : [],
        };
        submit(() => { }, peopleSubmit, data, close);
    }, [close, peopleSubmit, submit, type]);

    useEffect(() => {
        form.setFieldsValue({
            allowedPayCodes: user?.allowedPayCodes,
            excludedPayCodes: user?.excludedPayCodes,
        })
    }, [form, user?.allowedPayCodes, user?.excludedPayCodes]);

    useEffect(() => {
        const fieldErrors = generateErrorsConfigForForm(
            ["allowedPayCodes", "excludedPayCodes"],
            submittingError,
        );
        form.setFields(fieldErrors);
    }, [form, submittingError]);

    return (
        <Form form={form} onFinish={onFinish}>
            <div className="mb-3 d-flex align-items-center">
                <span
                    className={classNames(
                        "px-3 py-2 cursor-pointer border rounded",
                        type === "include" && "bg-info text-white"
                    )}
                    onClick={() => onTypeClick("include")}
                >
                    {t("include-pay-codes")}
                </span>
                <span
                    className={classNames(
                        "px-3 py-2 cursor-pointer border rounded",
                        type === "exclude" && "bg-info text-white"
                    )}
                    onClick={() => onTypeClick("exclude")}
                >
                    {t("exclude-pay-codes")}
                </span>
            </div>

            {type === "include" ? (
                <Field
                    name="allowedPayCodes"
                // label={t("include-pay-codes")}
                >
                    <ResourceSelect
                        resourcePath="/pay-code"
                        placeholder={t("pay-codes")}
                        renderLabel={renderSettingsResourceLabel}
                        getSearchFilters={getSettingsResourceSearchFilters}
                        mode="multiple"
                        hasSearch
                    />
                </Field>
            ) : (
                <Field
                    name="excludedPayCodes"
                // label={t("exclude-pay-codes")}
                >
                    <ResourceSelect
                        resourcePath="/pay-code"
                        placeholder={t("pay-codes")}
                        renderLabel={renderSettingsResourceLabel}
                        getSearchFilters={getSettingsResourceSearchFilters}
                        mode="multiple"
                        hasSearch
                    />
                </Field>
            )}

            <div className="d-flex justify-content-end">
                <Button
                    className="btn-round btn-icon shadow-none border btn btn-secondary btn-sm"
                    onClick={close}
                    disabled={submitting}
                >
                    {t("cancel")}
                </Button>

                <Button
                    className="btn-round btn-icon shadow-none border px-3 btn btn-dark btn-sm"
                    color="primary"
                    type="submit"
                    loading={submitting}
                    disabled={submitting}
                >
                    {t("save")}
                </Button>
            </div>
        </Form>
    );
}

export default ChangePayCodes;
